"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _classnames = _interopRequireDefault(require("classnames"));

var _nicbaseDatetimePicker = require("nicbase-datetime-picker");

var _nicbaseIcons = require("nicbase-icons");

var _nicbaseReducers = require("nicbase-reducers");

var _excluded = ["isMobile", "label", "className"];

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

var DateRangeFilter = function DateRangeFilter(_ref) {
  var isMobile = _ref.isMobile,
      label = _ref.label,
      className = _ref.className,
      other = _objectWithoutProperties(_ref, _excluded);

  var _useUser = (0, _nicbaseReducers.useUser)(),
      locale = _useUser.locale,
      timezone = _useUser.timezone;

  return /*#__PURE__*/_react["default"].createElement("div", {
    className: (0, _classnames["default"])('relative flex items-center', {
      'flex-1 m-0': isMobile
    }, className)
  }, /*#__PURE__*/_react["default"].createElement(_nicbaseIcons.Calendar, {
    className: "mr-2"
  }), /*#__PURE__*/_react["default"].createElement(_nicbaseDatetimePicker.DateRangePicker, _extends({
    inputLabel: label,
    locale: locale,
    timezone: timezone
  }, other)));
};

DateRangeFilter.propTypes = {
  isFilterFlyOut: _propTypes["default"].bool,
  className: _propTypes["default"].string,
  isMobile: _propTypes["default"].bool,
  enableRangeTemplates: _propTypes["default"].bool,
  label: _propTypes["default"].string,
  hideLabel: _propTypes["default"].bool,
  minDate: _propTypes["default"].oneOfType([_propTypes["default"].instanceOf(Date), _propTypes["default"].string, _propTypes["default"].number]),
  maxDate: _propTypes["default"].oneOfType([_propTypes["default"].instanceOf(Date), _propTypes["default"].string, _propTypes["default"].number]),
  from: _propTypes["default"].oneOfType([_propTypes["default"].instanceOf(Date), _propTypes["default"].string, _propTypes["default"].number]),
  until: _propTypes["default"].oneOfType([_propTypes["default"].instanceOf(Date), _propTypes["default"].string, _propTypes["default"].number]),
  enabledDate: _propTypes["default"].func,
  onChange: _propTypes["default"].func
};

var noop = function noop() {};

DateRangeFilter.defaultProps = {
  isFilterFlyOut: false,
  className: '',
  enableRangeTemplates: true,
  enabledDate: null,
  isMobile: false,
  label: null,
  hideLabel: false,
  from: null,
  until: null,
  minDate: null,
  maxDate: null,
  onChange: noop
};
var _default = DateRangeFilter;
exports["default"] = _default;